import getSubdomain from './getSubdomain'

const openLiveChat = (isAuthenticated: boolean, asPopup: boolean) => {
  const chattype: string = isAuthenticated ? 'authenticated' : 'unauthenticated'
  const mymedicareSubdomain: string = getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')
  const liveChatURL: string = `https://${mymedicareSubdomain}mymedicare.gov/webchatlogin.aspx?chattype=${chattype}`

  if (asPopup) {
    const liveChatWindow: Window | null = window.open(liveChatURL, 'LiveChat', 'height=730,width=680,scrollbars=1')

    liveChatWindow?.moveTo(50, 100)
  } else {
    window.open(liveChatURL, 'LiveChat')
  }
}

export default openLiveChat
